<template>
    <div class="Addguide">
        <!-- <public-title class="mt-3" v-if="!staff"  showBack>导游管理</public-title> -->
        <public-title class="mt-3" v-if="!staff">导游管理
            <span class="text-link ml-auto" @click="$router.push({name:'GuidesManage',query:{tab:$route.query.tab}})" slot="right">返回上一页</span>
        </public-title>
        <div class="bg-white">
            <el-alert class="mb-3" v-show="errorTips" :title="errorTips" type="error" center show-icon />
            <h4 class="bg-base p-3 text-left"  v-if="!staff">添加新人</h4>
            <div class="p-5">
                <div class="d-center-start  mb-3">
                <left-text leftText="身份"/>
                    <el-radio v-model="status" :label="'0'">导游</el-radio>
                    <el-radio v-model="status" :label="'1'">领队</el-radio>
                </div>
                <left-text-border leftText="姓名"  placeholder="请输入联系人" class="w-100 mb-3" v-model="linkman" />
                <!-- <div class="d-center-start  mb-3">
                <left-text leftText="性别"/>
                    <el-radio v-model="sex" :label="'1'">男</el-radio>
                    <el-radio v-model="sex" :label="'2'">女</el-radio>
                </div> -->
                <left-text-border leftText="手机号"  placeholder="请输入手机号" class="w-100 mb-3" v-model="phoneNumber" type="number" />
                <left-text-border leftText="确认手机号"  placeholder="请输入确认手机号" class="w-100 mb-3" v-model="confirmphoneNumber" type="number" />
                <div class="bottom-w">
                    <el-button class="bottomr" type="primary" @click="addGuide">确认添加</el-button>
                </div>
            </div>
        </div>

        <el-dialog title="请选择集团门店" :visible.sync="showChildren" width="70%" center :modal-append-to-body='false'>
            <el-radio-group v-model="radio" class="w-100">
                <el-radio :label="item.store_id" :key="item.store_id" class="w-50 ml-0 mb-4 mr-0"
                v-for="item in StoreLists.lists" :disabled="item.verify != 1">
                {{item.title}}
                <span v-show="item.verify != 1">({{item.verify | formatVar('verifyType')}})</span>
                </el-radio>
            </el-radio-group>
            <el-pagination background layout="prev, pager, next" class="mt-4 mb-4 text-center"
                :total="StoreLists.total" :current-page=page
                @current-change="v => {page=v;TraGroupGetStoreLists({ page:v, url })}"/>
            <el-button class="m-auto block" type="primary" @click="enSure">确 定</el-button>
        </el-dialog>
    </div>
</template>

<script>
import { mapState,mapGetters,mapActions } from 'vuex'
export default {
    name: 'AddGuide',
    data () {
        return {
            linkman: '',
            phoneNumber: '',
            confirmphoneNumber:'',
            phoneCode: '',
            errorTips: '',
            template: 'SMS_269225220',
            page: 1,
            radio: '',
            sex:'1',
            showChildren: false,
            url: '/pc/Travel/getStoreMaterial',
            status:'0',
        }
    },
    props:{
      staff:{},
      staffTab:{}
    },
    computed: {
        ...mapState(['StoreLists']),
        ...mapGetters(['storeInfo','isGroup']),
        queryCon() {return this.$route.query}
    },
    mounted () {
        if(this.staffTab){
            this.status=`${this.staffTab}`
        }
        console.log(this.staffTab);
        if (Boolean(this.queryCon.store) && !Boolean(this.queryCon.storeType)) {
            this.showChildren=true;
            this.radio = Number(this.queryCon.store)
            this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        }
        if(this.queryCon.tab)this.status=`${this.$route.query.tab}`
    },
    methods: {
        ...mapActions(['TraGroupGetStoreLists']),
        enSure () {
            this.$router.replace({name: 'AddGuide',query:{store:this.radio}})
            this.showChildren = false
        },
        // 添加新人
        async addGuide () {
            if (!this.$GFUN.guideName(this.linkman)) { this.$message.warning('请输入正确的新人名称'); return }
            if (!this.$GFUN.isPhone(this.phoneNumber)) { this.$message.warning('请输入正确的手机号码'); return }
            if (!this.$GFUN.isPhone(this.confirmphoneNumber)) { this.$message.warning('请再次输入正确的手机号码'); return }
            if (this.phoneNumber !== this.confirmphoneNumber)  {this.$message.warning('两次手机号不一致'); return };
            // if (!this.phoneCode) { this.$message.warning('请输入验证码'); return }
            this.open(this.linkman,this.phoneNumber)
           
        },
        async addGuides(){
            let url=''
             switch (this.status) {
                    case '0':url='/pc/Travel/AddGuide';break;   //添加新人
                    case '1':url='/pc/Travel/AddLeader';break;  //添加领队
                    default:break;
            }
            let res = await this.$axios.post(url, {
                store_id: this.isGroup ? this.$route.query.store : this.storeInfo.storeId,
                truename: this.linkman,
                mobile: this.phoneNumber,
                mobile2: this.confirmphoneNumber,
                sex: this.sex,
                // phoneCode: this.phoneCode,
            });
           if (res.code === '00000'){
                //清空填写值
                this.linkman='';
                this.phoneNumber='';
                this.confirmphoneNumber='';
                if(this.queryCon.tab)this.status=`${this.$route.query.tab}`;
                if(this.staff){
                        this.$message.success('添加成功');
                        this.$emit('addGuideList',true);
                }else{
                    this._alert('添加成功',() => {
                        this.$router.push({name: 'GuideManage', query: {...this.$route.query,page:1}})
                    })
                }
            }
        },
        open(linkman,phoneNumber) {
            const h = this.$createElement;
            this.$msgbox({
                title:'确认添加新人',
                message: h('div', null, [
                    h('span', null, '姓  名：'),
                    h('span', { style: 'color: #f72221' },linkman),
                    h('div', null,[
                        h('span', null, '手  机：'),
                        h('span', { style: 'color: #f72221' },phoneNumber)
                    ]),
                    
                ],),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.addGuides()
                        done();
                    } else {
                        done();
                    }
                }
            })
      }
    }
}
</script>

<style lang="scss" scoped>
.bottom-w{
    width: 280px;
    float: right;
    margin-top: 20px;
}
.p-5{
    padding-top: 60px !important;
    padding-bottom: 2rem !important;
    width: 400px;
    margin: 0 auto;
    overflow: hidden;
}
.bottomr {
    display: block;
    margin: 0 auto;
}
.sex span{
    margin-right: 10px;
}
.sex .el-radio{
    margin-right: 10px;
}
</style>